import { Injectable } from '@angular/core';
import { JSONRPCService } from '@s8l/client-tree-lib';

import { serviceURL } from './service';
import { LicenceUsage, TemplateProfile } from './user-server.service';

export interface ProductLicence {
  uuid?: string;
  product?: string;
  mail?: string;
  pattern: string;
  usage: LicenceUsage;
  precedence: number;
  volume: number;
  description?: string;
  profile: TemplateProfile;
}

export interface ShopifyPruchase {
  licence: string;
  existingLicenceKey?: string;
  sendMail: boolean;
  title: string;
  recipient: string;
  firstName: string;
  lastName: string;
  language: string;
}

export type Instant = any;

export interface ShopifyOrder {
  licence?: string;
  licenceKey?: string;
  title?: string;
  mail?: string;
  firstName?: string;
  lastName?: string;
  language?: string;
  timestamp?: Instant;
}

@Injectable({
  providedIn: 'root'
})
export class ShopifyServerService extends JSONRPCService {
  public licenceList(): Promise<ProductLicence[]> {
    return this.message(serviceURL('SHOPIFY_SERVER', '/licence'), 'list', {});
  }

  public licenceCreate(licence: ProductLicence): Promise<ProductLicence> {
    return this.message(serviceURL('SHOPIFY_SERVER', '/licence'), 'create', licence);
  }

  public licenceUpdate(licence: ProductLicence): Promise<ProductLicence> {
    return this.message(serviceURL('SHOPIFY_SERVER', '/licence'), 'update', licence);
  }

  public licenceDelete(uuid: string): Promise<any> {
    return this.message(serviceURL('SHOPIFY_SERVER', '/licence'), 'delete', { uuid });
  }

  public shopifyProductsList(): Promise<any[]> {
    return this.message(serviceURL('SHOPIFY_SERVER', '/shopify/product'), 'list', {});
  }

  public shopifyProductsPurchase(purchase: ShopifyPruchase): Promise<any> {
    return this.message(serviceURL('SHOPIFY_SERVER', '/shopify/product'), 'purchase', purchase);
  }

  public shopifyProductsOrders(): Promise<ShopifyOrder[]> {
    return this.message(serviceURL('SHOPIFY_SERVER', '/shopify/product'), 'orders', {});
  }

  public mailTemplatesList(): Promise<string[]> {
    return this.message(serviceURL('SHOPIFY_SERVER', '/mail/template'), 'list', {});
  }
}
